import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import { PldSearchResult, PldSearchResultRisk, PldSearchResultSumary } from "@interfaces/pld";
import { Response } from "@interfaces/response";

const pldApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPldSearchResults: build.query<Array<PldSearchResult>, UUID>({
            query: (applicationId) => ({
                url: `pld/search_results`,
                params: {
                    loan_application_id: applicationId,
                },
            }),
            transformResponse: (response: Response<Array<PldSearchResult>>) => {
                return response.data;
            },
        }),
        getPldSearchResultSumary: build.query<Array<PldSearchResultSumary>, UUID>({
            query: (applicationId) => ({
                url: `pld/search_results_sumary`,
                params: {
                    loan_application_id: applicationId,
                },
            }),
            transformResponse: (response: Response<Array<PldSearchResultSumary>>) => {
                return response.data;
            },
        }),
        getPldSearchResultRisk: build.query<PldSearchResultRisk, UUID>({
            query: (applicationId) => ({
                url: `pld/search_results_risk`,
                params: {
                    loan_application_id: applicationId,
                },
            }),
            transformResponse: (response: Response<PldSearchResultRisk>) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useLazyGetPldSearchResultsQuery,
    useGetPldSearchResultsQuery,
    useLazyGetPldSearchResultSumaryQuery,
    useLazyGetPldSearchResultRiskQuery,
} = pldApi;
